<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="标题" prop="title">
            <el-input class="form-input" v-model="searchForm.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="rollingStatus">
            <el-select v-model="searchForm.rollingStatus" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人" prop="creatorName">
            <el-input class="form-input" v-model="searchForm.creatorName" clearable></el-input>
          </el-form-item>
          <el-form-item label="修改日期" prop="updatedTime">
            <q-date-picker startFiled="updatedTimeStart" endFiled="updatedTimeEnd" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="handleAdd(null, 1)">新增</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        border
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="sortNo" label="轮播顺序" width="120" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorName" label="创建人" width="100" align="center"></el-table-column>
        <el-table-column prop="updatedTime" label="修改时间" width="155">
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="rollingStatus" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.rollingStatus | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="180" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button v-if="scope.row.rollingStatus == 0" type="text" size="small" @click="handleState(scope.row, 1)">下线</el-button>
            <el-button v-else type="text" size="small" @click="handleState(scope.row, 0)">上线</el-button>
            <el-button v-if="scope.row.rollingStatus == 1" type="text" size="small" @click="handleAdd(scope.row, 2)">修改</el-button>
            <el-button type="text" size="small" @click="handleAdd(scope.row, 3)">查看</el-button>
            <el-button v-if="scope.row.rollingStatus == 1" type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-image
      v-if="isShowAdd" 
      :visible.sync="isShowAdd" 
      :modifyData="modifyData" 
      :actionType="actionType"
      @success="getList"
    />
  </content-panel>
</template>

<script>
import AddImage from './add-image.vue'
import tableMixin from '@/utils/tableMixin';
export default {
  name: 'ImageCarouselList',
  mixins: [tableMixin],
  components: {
    AddImage
  },
  data() {
    return {
      searchForm: {
        title: '',
        status: '',
        rollingStatus: '',
        creatorName: '',
        updatedTimeStart: '',
        updatedTimeEnd: '',
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      statusOptions: [
        {value: '', label: '全部'},
        {value: 0, label: '使用中'},
        {value: 1, label: '已下线'},
      ],
      actionType: 1,
      isShowAdd: false,
      modifyData: null
    }
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.carouselImage.getList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.updatedTimeStart = ""
      this.searchForm.updatedTimeEnd = ""
      this.$refs.dateRef.reset()
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;
    },
    handleState(row, state) {
      this.$api.carouselImage
        .updateState(row.rollingId, state)
        .then(({data}) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.getList();
        });
    },
    handleDelete(row) {
      this.$confirm('删除后数据不可恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.carouselImage
            .updateState(row.rollingId, 2)
            .then(({data}) => {
              this.$notify.success({
                title: '成功',
                message: '删除成功',
              });
              this.getList();
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
  },
  filters: {
    statusEnum(val) {
      const map = {
        0: '使用中',
        1: '已下线',
        2: '已删除',
      };
      return map[val] || '';
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input {
  width 130px !important
}
.to {
  display: inline-block;
  margin: 0 4px;
}
</style>